import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaInput } from './KaInput.vue';

export type { KaInputProps } from './KaInput.vue';

export const KaInputVee = veeFormFieldHOC(KaInput);

export { KaInput };
